export default __webpack_public_path__ + "static/media/close.a88488a5.svg";